// The transport contract (Milestone 7.3), as a throwing abstract base in the
// same style as IPlayer and SnapshotProvider.
//
// Everything above this line (PlayBidApiClient, the DTO builders, the UI) is
// written against `request()` alone. That is what makes HttpTransport and
// MockTransport genuinely interchangeable: the client cannot tell which one it
// holds, so a Reference Application running against the mock exercises the
// same code path that will later run against the real backend.
export class ApiTransport {
  /**
   * @param {object} request
   * @param {string} request.method    HTTP verb.
   * @param {string} request.path      Path beginning with '/', e.g. '/v1/config'.
   * @param {object} [request.query]   Serialized into a query string.
   * @param {object} [request.body]    JSON request body.
   * @param {object} [request.headers] Additional headers.
   * @param {number} [request.timeout] Per-request override.
   * @param {AbortSignal} [request.signal]
   * @returns {Promise<{status: number, data: any, requestId: string|null}>}
   */
  // eslint-disable-next-line no-unused-vars
  request(request) {
    throw new Error('ApiTransport.request() must be implemented by a subclass');
  }
}
